import React from 'react';
import { Card } from '@/components/ui/card';

// Shared by the public "Check Availability" page and the "Book Court" Step 1
// screen so the legend text/colors can never drift out of sync between them.
export default function AvailabilityLegend() {
  return (
    <Card className="p-6 mt-8" data-testid="availability-legend">
      <h4 className="text-sm font-bold uppercase mb-4">Availability Legend</h4>
      <div className="flex flex-wrap gap-6">
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-green-100 border-2 border-green-700 rounded"></div>
          <span className="text-sm">Available (60%+)</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-orange-100 border-2 border-orange-700 rounded"></div>
          <span className="text-sm">Limited (1-40%)</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-red-100 border-2 border-red-700 rounded"></div>
          <span className="text-sm">Fully Booked</span>
        </div>
      </div>
    </Card>
  );
}
